import React from "react";

import {
  DescriptionWrapper,
  InfomationsText,
  LimitText,
  LimitWrapper,
} from "../styles";
import { TLimitInformationContainer } from "./types";

const LimitInformationContainer: React.FC<TLimitInformationContainer> = ({
  limiteExtra,
  limitePrincipal,
  saldoDisponivel,
  saldoDisponivelExtra,
  total,
  utilizaLimiteExtra,
  devedorTotal,
}) => {
  const formatter = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
  return (
    <LimitWrapper>
      {utilizaLimiteExtra && (
        <LimitWrapper>
          <LimitText>Total = Limite + Extra</LimitText>
          <InfomationsText>
            {formatter.format(total)} = {formatter.format(limitePrincipal)} +{" "}
            {formatter.format(limiteExtra)}
          </InfomationsText>
        </LimitWrapper>
      )}

      <DescriptionWrapper>
        <LimitText>Devedor Total = </LimitText>
        <InfomationsText>{formatter.format(devedorTotal)} </InfomationsText>
      </DescriptionWrapper>
      <DescriptionWrapper>
        <LimitText>Saldo Disponível = </LimitText>
        <InfomationsText>{formatter.format(saldoDisponivel)}</InfomationsText>
      </DescriptionWrapper>
      {utilizaLimiteExtra && (
        <DescriptionWrapper>
          <LimitText>Saldo Disponível Extra = </LimitText>
          <InfomationsText>
            {formatter.format(saldoDisponivelExtra)}
          </InfomationsText>
        </DescriptionWrapper>
      )}
    </LimitWrapper>
  );
};

export default LimitInformationContainer;
